import { IRequiredAction } from './requiredActions.types';

export const getActionTypes = (requiredActions: IRequiredAction[]): string[] => requiredActions.map(ra => ra.type);

export const getActionTypeValueFn = (type: string) => (requiredActions: IRequiredAction[]): boolean | string => {
  const requiredAction = requiredActions.find(item => item.type === type);
  return requiredAction?.value ?? '';
};
